import { ListItem } from 'reservations/base/components/ListItem';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  useBookingDetails,
  useBookingHasFee
} from 'reservations/booking/providers/BookingProvider';
import { useExternalUrl } from 'reservations/booking/providers/BookingProvider';
import { useIsCanceled } from 'reservations/booking/providers/BookingProvider';
import { useIsLead } from 'reservations/booking/providers/BookingProvider';
import { useBookingFee } from 'reservations/booking/providers/BookingProvider';
import { RESERVATION_SETTINGS_HEADER } from 'reservations/checklessPayments/constants';
import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';
import { getFormattedFeeToCharge } from 'reservations/feePolicy/helpers';
import { useLateCancel } from 'reservations/feePolicy/hooks';

const ReservationDetailsModule = () => {
  const { open } = useModal();
  const { dietaryTags, note, tags } = useBookingDetails();
  const isLead = useIsLead();
  const hasFee = useBookingHasFee();
  const { hasExternalUrl, redirectToExternalUrl } = useExternalUrl();
  const isCanceled = useIsCanceled();
  const { dateAndTime, partySize } = useBookingDetails();
  const fee = useBookingFee();
  const formattedFeeToCharge = getFormattedFeeToCharge(fee, partySize);
  const { cancellationDeadline } = useLateCancel(dateAndTime, fee);

  if (isCanceled || !isLead) {
    return null;
  }

  const titleCaseTags = tags?.map((tag: string) =>
    tag
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );

  return (
    <BookingConfirmationDetailCard header={RESERVATION_SETTINGS_HEADER}>
      <ListItem
        primaryLabel="Special occasion"
        secondaryLabel={titleCaseTags?.join(', ') || 'None'}
        onClick={
          hasExternalUrl
            ? redirectToExternalUrl
            : () => open(ModalType.SpecialOccasion)
        }
      />
      <ListItem
        primaryLabel="Special requests"
        secondaryLabel={note || 'None'}
        onClick={
          hasExternalUrl
            ? redirectToExternalUrl
            : () => open(ModalType.SpecialRequest)
        }
        includeDivider={hasFee || hasExternalUrl}
      />
      {hasExternalUrl && (
        <ListItem
          primaryLabel="Allergies & food preferences"
          secondaryLabel={dietaryTags?.join(', ') || 'None'}
          //TODO: Replace empty function with open modal handler once implemented
          // istanbul ignore next
          onClick={hasExternalUrl ? redirectToExternalUrl : () => {}}
          includeDivider={hasFee}
        />
      )}
      {hasFee && (
        <ListItem
          primaryLabel="Cancellation policy"
          secondaryLabel={`No-shows or cancellations after
    ${COMMON_DATETIME_FORMATS.dayDateAndTime(cancellationDeadline)} are
      subject to a fee of ${formattedFeeToCharge}.`}
          includeDivider={false}
        />
      )}
    </BookingConfirmationDetailCard>
  );
};

export default ReservationDetailsModule;
